import MediaPlanning from './MediaPlanning';

export default MediaPlanning;
